import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `unit_availability` anchor component.
 * Keep in sync with UnitAvailabilityProps in src/ui/uiConfig/anchorComponents/UnitAvailability/UnitAvailability.types.ts
 */
export const unitAvailabilityPropDocs: ComponentDocMap = {
  unitAvailabilityUnits: {
    description: 'Units rendered in the unit availability widget.',
    type: 'UnitAvailabilityUnitWidget[]',
    example:
      '[{ unit_name: "boiler_a", unit_display_name: "Boiler A", kpi: { ui_config_id: 21 }, chart: { ui_config_id: 22 } }]',
  },
  'unitAvailabilityUnits[].unit_name': {
    description: 'Backend unit identifier.',
    type: 'string',
  },
  'unitAvailabilityUnits[].unit_display_name': {
    description: 'Optional display name in UI.',
    type: 'string',
  },
  'unitAvailabilityUnits[].kpi.ui_config_id': {
    description: 'KPI ui_config reference for the unit.',
    type: 'number',
  },
  'unitAvailabilityUnits[].chart.ui_config_id': {
    description: 'Chart ui_config reference for the unit.',
    type: 'number',
  },
  systemId: {
    description: 'Current system id (runtime injected).',
    type: 'number',
  },
}
